import { useEffect } from 'react';

export const useBodyOverflow = (active: boolean = true) => {
  useEffect(() => {
    if (!active) return;

    const body = document.body;
    const count = Number(body.dataset.overflowLockCount ?? '0');

    if (count === 0) {
      body.dataset.prevOverflow = body.style.overflow ?? '';
    }

    body.dataset.overflowLockCount = String(count + 1);
    body.style.overflow = 'hidden';

    return () => {
      const current = Number(body.dataset.overflowLockCount ?? '0');
      const next = Math.max(0, current - 1);
      body.dataset.overflowLockCount = String(next);

      if (next === 0) {
        body.style.overflow = body.dataset.prevOverflow ?? '';
        delete body.dataset.prevOverflow;
        delete body.dataset.overflowLockCount;
      }
    };
  }, [active]);
};

export default useBodyOverflow;
